import { watch, ref } from "vue";
import { isString } from "@/utils/is";

export const useTitle = (newTitle?: string) => {
  const VITE_APP_TITLE = import.meta.env.VITE_APP_TITLE;
  const title = ref(newTitle ? `${newTitle as String}` : VITE_APP_TITLE);

  watch(
    title,
    (n, o) => {
      if (isString(n) && n !== o && document) {
        document.title = n;
      }
    },
    { immediate: true }
  );

  return title;
};
